"use client";
/* eslint-disable @next/next/no-img-element */

import { FormEvent, useState } from "react";
import { AppUser, DEMO_USERS } from "./empi-model";

export const DEMO_ADMIN_USERNAME = "admin";
export const DEMO_ADMIN_PASSWORD = "IdentitySpot@2026";

export default function LoginScreen({onSuccess}:{onSuccess:(user:AppUser)=>void}){
  const [username,setUsername]=useState("");
  const [password,setPassword]=useState("");
  const [showPassword,setShowPassword]=useState(false);
  const [error,setError]=useState("");
  const [busy,setBusy]=useState(false);

  function submit(event:FormEvent){
    event.preventDefault();setError("");setBusy(true);
    window.setTimeout(()=>{
      const user=DEMO_USERS.find(item=>item.username===username.trim().toLowerCase()&&item.password===password);
      if(user){window.sessionStorage.setItem("identityspot-demo-user",user.username);window.sessionStorage.setItem("identityspot-demo-auth","admin");onSuccess(user)}
      else{setBusy(false);setError("The username or password is incorrect.")}
    },350);
  }
  function useAdmin(){setUsername(DEMO_ADMIN_USERNAME);setPassword(DEMO_ADMIN_PASSWORD);setError("")}

  return <main className="login-shell">
    <section className="login-brand-panel">
      <div className="login-brand-lockup"><img src="/dse-logo.png" alt="DataSpotEye"/><span/><div><strong>IdentitySpot™</strong><small>Enterprise Master Patient Index</small></div></div>
      <div className="login-story"><p>San Mateo County demonstration</p><h1>One trusted identity.<br/>Every connected system.</h1><span>Resolve duplicates, protect patient records, and govern the complete identity lifecycle through one secure workspace.</span></div>
      <div className="login-capabilities"><div><b>17</b><span>Configured source systems</span></div><div><b>99.2%</b><span>Validated match precision</span></div><div><b>24/7</b><span>Operational visibility</span></div></div>
      <small className="login-disclaimer">Synthetic demonstration environment. No real patient information or PHI is present.</small>
    </section>
    <section className="login-form-panel">
      <form className="login-card" onSubmit={submit}>
        <div className="login-mark">IS</div><p className="login-eyebrow">Secure role-based access</p><h2>Welcome to IdentitySpot</h2>
        <span className="login-copy">Sign in to access the workflows permitted for your assigned enterprise role.</span>
        <label htmlFor="identityspot-username">Username</label><input id="identityspot-username" autoComplete="username" value={username} onChange={event=>setUsername(event.target.value)} placeholder="Enter username" required autoFocus/>
        <label htmlFor="identityspot-password">Password</label><div className="password-field"><input id="identityspot-password" type={showPassword?"text":"password"} autoComplete="current-password" value={password} onChange={event=>setPassword(event.target.value)} placeholder="Enter password" required/><button type="button" onClick={()=>setShowPassword(value=>!value)}>{showPassword?"Hide":"Show"}</button></div>
        {error&&<div className="login-error" role="alert">{error}</div>}
        <button className="login-submit" type="submit" disabled={busy}>{busy?"Signing in…":"Sign in securely"}</button>
        <button className="demo-credential-button" type="button" onClick={useAdmin}>Use default administrator credentials</button>
        <div className="login-security"><span>🔒</span><div><b>Role-enforced demonstration</b><small>Menus and landing pages change by authenticated role.</small></div></div>
      </form>
      <p className="login-footer">DataSpotEye · IdentitySpot™ EMPI · Demo Release 1.5.1</p>
    </section>
  </main>;
}
